import { render, staticRenderFns } from "./QueryTapirMk.vue?vue&type=template&id=940f5726&scoped=true&"
import script from "./QueryTapirMk.vue?vue&type=script&lang=js&"
export * from "./QueryTapirMk.vue?vue&type=script&lang=js&"
import style0 from "./QueryTapirMk.vue?vue&type=style&index=0&id=940f5726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940f5726",
  null
  
)

export default component.exports